import React from 'react';
import { Switch } from 'antd';

const SbSwitch = ({ checked = false, onChange, disabled = false, ...rest }) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...rest}
    />
  );
};

export default SbSwitch;